import { Component, OnInit, Input } from '@angular/core';
import { Team, TeamOverviewModel } from '../shared/team.model';
import { MatCard, MatCardHeader, MatCardAvatar, MatCardTitle, MatCardSubtitle, MatCardContent, MatCardActions } from '@angular/material/card';

import { HighScoreComponent } from '../shared/high-score/high-score.component';
import { MatIconAnchor } from '@angular/material/button';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-team-overview-card',
    templateUrl: './team-overview-card.component.html',
    styleUrls: ['./team-overview-card.component.css'],
    imports: [MatCard, MatCardHeader, MatCardAvatar, MatCardTitle, MatCardSubtitle, MatCardContent, HighScoreComponent, MatCardActions, MatIconAnchor, RouterLink]
})
export class TeamOverviewCardComponent implements OnInit {
  
  @Input() Team: TeamOverviewModel;

  constructor() { }

  ngOnInit() {



  }


}
